import React from 'react';
import { Navigate } from 'react-router-dom';
import { isInternalPortalToolsEnabled } from '../utils/portalAccess';
import { useTenant } from '../contexts/TenantContext';

const RequireInternalPortalTool = ({ children }) => {
  const { userRole } = useTenant();
  if (!isInternalPortalToolsEnabled({ role: userRole })) {
    return <Navigate to="/app/settings" replace />;
  }
  return children;
};

export default RequireInternalPortalTool;
